import baseConfiguration from './base.configuration';
import myConfiguration from './my.configuration';
import sgConfiguration from './sg.configuration';
import idConfiguration from './id.configuration';
import thConfiguration from './th.configuration';
import { ReviewAppService } from '../app/services/review-app.service';
import { ENVIRONMENT } from '../environments/environment';

const DEFAULT_COUNTRY_CODE = 'my';
const TESTING_APP_URL_KEY = ['preview', 'localhost'];
const configurations = {
  'my': myConfiguration,
  'sg': sgConfiguration,
  'id': idConfiguration,
  'th': thConfiguration
};

const landingPagesByCountry = {
  refer: {
    MY: '/refer',
    SG: '/refer'
  },
  smeLoans: {
    SG: '/sme-loans',
  },
  smeFinancing: {
    MY: '/sme-financing',
  },
  p2pInvestment: {
    SG: '/investment',
  },
  invest: {
    ID: '/invest',
    MY: '/invest',
    TH: '/investor',
  },
  partnersPortal: {
    SG: '/partner-portal',
  },
  pressAssets: {
    SG: '/press-assets',
  },
  termConditions: {
    MY: '/term-condition'
  },
  termsOfUse: {
    SG: '/terms-of-use'
  },
  borrow: {
    ID: '/pinjaman-online',
  },
  signUp: {
    MY: '/sign-up',
    SG: '/sign-up',
    TH: '/sign-up'
  },
  borrowProductList: {
    ID: '/pinjaman-online#product',
    TH: '/financing-application',
    SG: '/get-started',
    MY: '/sme-financing',
  },
  aboutUs: {
    SG: '/about-us',
    TH: '/about-us',
  },
  ourCompany: {
    SG: '/about-us',
  },
  leadershipTeam: {
    SG: '/about-us#leadershipteam',
  },
  inTheNews: {
    SG: '/in-the-news/2021', // need to update every year
  },
  career: {
    SG: '/career',
  },
  microFinancing: {
    MY: '/sme-micro-financing',
  },
  invoiceFinancing: {
    MY: '/invoice-financing',
  },
  businessTermFinancing: {
    MY: '/term-financing',
  },
  dealerFinancing: {
    MY: '/dealer-financing',
  },
  microCreditLine: {
    MY: '/micro-credit-line',
  },
  personalisedFinancing: {
    MY: '/sme-financing/start-application',
  },
  privacyNotice: {
    SG: '/privacy-notice',
    TH: '/privacy-notice',
  },
  websiteTerms: {
    TH: '/website-terms',
  }
};

const LandingPageProperties = {
  aboutUs: {
    dropdown: ['SG']
  }
};

export const hasLandingPageFor = (page: string, countryCode: string): Boolean => {
  if (landingPagesByCountry[page]) {
    const landingPageCountries = Object.keys(landingPagesByCountry[page]);
    return landingPageCountries.includes(countryCode);
  }

  return false;
}

export const getLandingPageProperties = (page: string): Boolean => {
  if (LandingPageProperties[page]) {
    return LandingPageProperties[page]
  }
  return false;
}

export const landingPagePathFor = (page: string, countryCode: string): string => {
  if (landingPagesByCountry[page]) {
    return landingPagesByCountry[page][countryCode];
  }

  return '';
}

let selectedCountry = '';

function getCountryCodeAccordingToUrl(baseUrls, host): string {
  if (!baseUrls || !host) {
    return '';
  } else {
    for (const key in baseUrls) {
      if (baseUrls[key].find(baseUrl => baseUrl === host)) {
        return key;
      }
    }
    return '';
  }
}

export function isTestingEnvironment(): Boolean {
  return TESTING_APP_URL_KEY.some(v => window.location.origin.includes(v));
}
// For review app, get country code from localstorage
if (isTestingEnvironment()) {
  const countryService = new ReviewAppService();
  selectedCountry = countryService.getCountry() || DEFAULT_COUNTRY_CODE;
  // else gettting it from the url
} else {
  const countryCode = getCountryCodeAccordingToUrl(ENVIRONMENT.baseUrls, window.location.host);
  selectedCountry = countryCode !== '' ? countryCode : DEFAULT_COUNTRY_CODE;
}

export default Object.freeze(Object.assign({}, baseConfiguration, configurations[selectedCountry]));
